<template lang="pug">
  page
    .flex-fill.d-flex.flex-column.justify-content-center
      .container-tight.py-6
        .text-center.mb-4
          img(src="@/assets/logo.png")
          //- h2 Portal
        form.card.card-md(action="#" method="post" @submit.prevent="loginAction()")
          //- input(name="_token" :value="csrf_token" type="hidden")
          .card-body
            h2.mb-5.text-center Forgot Password
            .mb-3
              label.form-label Email address
              input.form-control(:class="errors.email?'is-invalid':''" name="email" type='email' placeholder='Enter email' autocomplete='off' v-model="form.email")
              form_error(:errors="errors.email")
            .form-footer.text-center
              loading_btn.btn-block(type='submit' :loading="sending") Request Reset Link

</template>

<script>
import { mapState, mapActions } from 'vuex'
import loadingBtn from '@/components/loadingBtn';
import form_error from '@/components/formErrors';
import page from '@/components/page_blank';

export default {
  components:{
     'loading_btn': loadingBtn,
     form_error,
      page
  },
  data(){
    return {
      form: {
        email: '',
      },
    }
  },
  computed: {
    ...mapState('api', ['errors','sending']),
  },
  methods:{
    loginAction(){
      var vm = this;
      this.call({_vm: vm, endpoint: `password/email`, method: 'POST', data: this.form}).then(()=>{
        vm.form.email = "";
      })
    },
    ...mapActions('api',['call'])
  }
}
</script>